var _rect, _path, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHeaderKey(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 66,
    viewBox: "0 0 67 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.44531,
    y: 5,
    width: 56,
    height: 56,
    rx: 28,
    fill: "#F2F4F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.5286 27.7502L41.6119 23.6668M43.9453 21.3335L41.6119 23.6668L43.9453 21.3335ZM32.7336 32.5452C33.336 33.1395 33.8149 33.8472 34.1426 34.6274C34.4704 35.4076 34.6406 36.245 34.6435 37.0912C34.6463 37.9375 34.4817 38.776 34.1592 39.5583C33.8366 40.3407 33.3625 41.0516 32.7641 41.65C32.1657 42.2484 31.4548 42.7225 30.6725 43.0451C29.8901 43.3676 29.0516 43.5322 28.2053 43.5294C27.3591 43.5265 26.5217 43.3563 25.7415 43.0285C24.9613 42.7008 24.2536 42.2219 23.6593 41.6195C22.4904 40.4093 21.8437 38.7884 21.8583 37.106C21.8729 35.4236 22.5477 33.8142 23.7374 32.6245C24.9271 31.4348 26.5365 30.76 28.2189 30.7453C29.9014 30.7307 31.5222 31.3775 32.7324 32.5463L32.7336 32.5452ZM32.7336 32.5452L37.5286 27.7502L32.7336 32.5452ZM37.5286 27.7502L41.0286 31.2502L45.1119 27.1668L41.6119 23.6668L37.5286 27.7502Z",
    stroke: "#475467",
    strokeWidth: 2.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5.44531,
    y: 5,
    width: 56,
    height: 56,
    rx: 28,
    stroke: "#F9FAFB",
    strokeWidth: 10
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderKey);
export default __webpack_public_path__ + "static/media/header-key.053e5fe2fbe447644fd3f62883c68796.svg";
export { ForwardRef as ReactComponent };